import { Component, OnInit, Input, ViewChild, ElementRef, HostListener, Output, EventEmitter } from '@angular/core';
import { Header } from '../../models/header.model';
import { UIBaseService } from '../../services/uibase.service';
import { Router, ActivatedRoute } from '@angular/router';
import { catchError, switchMap, startWith, debounceTime } from 'rxjs/operators';
import { interval, of } from "rxjs";
import { DataService } from '../../services/data.service';
import { UIDataService } from '../../../modules/customer-care/services/uidata.service';
import { Deligation } from '../../../modules/customer-care/models/catalog.model';
import { SearchService } from '../../services/search.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { LanguageService } from '../../services/language-service';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'cop-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})

export class HeaderComponent implements OnInit {

  @Output() hideOtherCompsEmit: EventEmitter<boolean> = new EventEmitter();
  header!: Header;
  firstName: string = "";
  lastName: string = "";
  showMenu = false;
  infoMenu = false;
  pollingData: any;
  userType: string = "";
  showHideSearch: boolean = false;
  close: boolean = true;
  dropDownShow: boolean = false;
  viewSettingIcon: boolean = false;
  views: any[] = [];
  filterInput: any;
  suggestionList: any = [];
  @Input() search!: string;
  @ViewChild('fileinput') fileinput!: ElementRef;
  selectedDropdown: string = '';
  checkingDown: any;
  viewId: any;
  disableApplySetting: boolean = true;
  hideMobile: boolean = false;
  searchFieldResponse: any;
  status: any;
  counter: number = 0;
  showInvalidDelegationMsg = false;
  addButtonEnable = false;
  hideListMenus: boolean = false;
  userIdresponse: any;
  deligationInitialResponse: any;
  deligationData: any;
  responseArray: any[] = [];
  jointArray: any[] = [];
  url: string = '';
  initialDefaultDropdown: any;
  limitedDeligation: boolean = false;
  addButtonFlag: boolean = false;
  activeInputUserArray = [];
  listOFRequests = [];
  mergedUserid = [];
  finalInputArray = [];
  hideInitalResponseInputBox = false;
  trimedInputvaluesBoolean = false;
  logout: string = "";
  defaultSettingIcon: boolean = false;
  originUrl: string = "";
  userInfo: any;
  disabledSelect: boolean = true;
  greyTitleText = "";
  isSearchTermBlank: boolean = false;
  change: boolean = false;
  filterDocumentType = "all";
  filterContentType = "all";
  FilterType = "Relevence";
  environmentUrlIslocal: boolean = false;
  stat = [
    { 'name': 'Avaya Knowledge', 'key': 'avayaknowledge' },
    { 'name': 'OneCare Service Catalog', 'key': 'onecareservice_catalog' }
  ];
  public deviceType: string = "";
  searchResultJsonResponse: string = "";
  isLoadingResults: boolean = false;
  totalRecords: any;
  fromSearchResult: number = 0;
  pageChange: number = 0;
  toSearchResult: number = 0;
  checkUrl: boolean = false;
  profile: string = 'avaya_en';
  searchUrl: string = "";
  searchTerm: string = "";
  delegationBoolean: boolean = false;
  delegationOriginUrl: string = "";
  myrequestsOriginUrl: string = "";
  historyOriginUrl: string = "";
  isOpenTableView: boolean = false;
  filterCategory = "all";
  filterLang = "all";
  filtered: any;
  selected: any;
  userprofileForm: UntypedFormGroup | undefined;
  localLangCode: string = "";
  envName: string = environment.envName;
  searchCtrl: UntypedFormControl = new UntypedFormControl();
  isLoading: boolean = false;
  snackBarConfig = <MatSnackBarConfig>environment.snackBarConfig;
  noSuggestion: boolean = false;
  isMobView: boolean = false;
  toHighlight: string = "";
  oneCareAvayaKnowledgeMsg: string = "";
  leftMenus: any[] = [];
  rightMenus: any[] = [];
  isNoLeftMenus: boolean = false;

  @HostListener('window:resize', ['$event'])
    onResize(event: any) {
      if(window.innerWidth < 768)
        this.isMobView = true;
      else
        this.isMobView = false;
    }

  public constructor(
    private fb: UntypedFormBuilder,
    private uibase: UIBaseService,
    private router: Router,
    private route: ActivatedRoute,
    private ds: DataService,
    private ui: UIDataService,
    private el: ElementRef,
    private searchservice: SearchService,
    private languageService: LanguageService,
    private translator: TranslateService
  ) { }

  ngOnInit() {
    let currentUrl = window.location.href;
    this.userprofileForm = this.fb.group({
      mobiles: this.fb.array([
        this.fb.control('')
      ])
    });
    this.localLangCode = this.languageService.localCode;

    if(window.innerWidth < 768)
      this.isMobView = true;
    else
      this.isMobView = false;

    /**
      * logout url updated according to "view" param in url
      */
    if (window.location.href.includes("AvayaOneCloudPrivate"))
      this.logout = environment.pci_signout + "AvayaEnterpriseCloud";
    else if (window.location.href.includes("AvayaEnterpriseCloud"))
      this.logout = environment.pci_signout_aec + "AvayaEnterpriseCloud";
    else if(window.location.href.includes("AvayaAuraPrivateCloud"))
      this.logout = environment.pci_signout_aec + "AvayaAuraPrivateCloud";
    else {
      // if(this.envName === "prod del env" || this.envName === "prod mgm env")
      //   this.logout = environment.sso_signout + "?source=" + window.location.origin + this.localLangCode;
      // else
      if(this.envName === "prod del env" && window.location.origin.includes("ocp.avaya.com"))
        environment.sso_signout = environment.sso_signout + "_ocp";
      else if(this.envName === "prod mgm env" && window.location.origin.includes("cms.avaya.com"))
        environment.sso_signout = environment.sso_signout + "_cms";

      this.logout = window.location.origin + "/customercare" + this.localLangCode + environment.sso_signout;
    }

    this.originUrl = window.location.origin + "/customercare" + this.localLangCode + "/home";
    // Subscribe to userProfileForm Value Changes
    this.userProfileFormValueChanges();

    this.filterInput = this.ui;
    this.filterInput = this.filterInput.getUIData("TicketCatalogComponent", "TicketCatalogComponent1378121271914");
    this.getSearchTerm()
    if (Array.isArray(this.filterInput)) {
      this.filterInput.forEach(element => {
        if (element.views && element.views.length > 0) {
          element.views.forEach((child: any) => this.views.push(child));
        }
      });
    }

    if (this.views.length > 1) {
      this.disableApplySetting = false;
    }
    this.checkingDown = this.views.forEach(defaultview => {
      if (defaultview.defaultview) {
        this.viewId = defaultview.id;
        this.initialDefaultDropdown = defaultview.id;
      }
    });

    this.header = new Header(
      this.uibase.pageHeader['logo'],
      this.uibase.pageHeader['headerLinks'],
      this.uibase.pageHeader['usersettings']
    );

    if(this.header && this.header._headerlinks) {
      this.header._headerlinks.forEach((elem: any) => {
        if(elem.HasSubHeaderLink && elem.HasSubHeaderLink === "true")
          elem.HasSubHeaderLink = true;
        else
          elem.HasSubHeaderLink = false;

        if(elem.alttext === "language") {
          (elem.SubHeaderLinks && elem.SubHeaderLinks.length) && elem.SubHeaderLinks.forEach((link: any) => {
            link["isSelectedLang"] = false;

            if(this.localLangCode.includes("en") && (link.alttext === "English"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("de") && (link.alttext === "Deutsch"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("nl") && (link.alttext === "Dutch"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("fr") && (link.alttext === "French"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("it") && (link.alttext === "Italian"))
              link.isSelectedLang = true;
            else if(this.localLangCode.includes("es") && (link.alttext === "Espanol"))
              link.isSelectedLang = true;
            else
              link.isSelectedLang = false;
          });
        }
      });

      const separatorIdx = this.header._headerlinks.findIndex((obj: any) => obj.alttext === "Header-Separator");
      this.leftMenus = this.header._headerlinks.slice(0, separatorIdx);
      this.isNoLeftMenus = (this.leftMenus.length === 0);
      this.rightMenus = this.header._headerlinks.slice(separatorIdx + 1);
    }
    // console.log("header", this.header);

    this.firstName = this.uibase.userInfo.First_Name;
    this.lastName = this.uibase.userInfo.Last_Name;
    this.userInfo = this.uibase.userInfo;
    this.userType = this.uibase.userInfo.usertype;

    // console.log("user info", this.uibase);

    let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      this.hideMobile = true
    } else {
      this.hideMobile = false;
    }

    // ping sso token idle expiry time = 60 minutes(3600000 miliseconds)
    this.pollingData = interval(3600000)
      .pipe(
        startWith(0),
        switchMap(() => this.ds.getSessionDataOf('checksession')
          .pipe(
            catchError((error) => of(`ERROR sending data ${error}`))
          )
        ))
      .subscribe((response: any) => {
        if (response.status === 302) {
          window.location.reload();
        }
      });

    // If in case, need to check for user session by using 'PA.wsocponecare' cookie
    // this.pollingData = interval(60000)
    // .pipe(
    //   startWith(0),
    //   switchMap(() => this.ds.getSessionDataOf('checksession')
    //   .pipe(catchError((error) =>of(`ERROR sending data ${error}`))))
    // ).subscribe((response: any) => {
    //   let sess = this.cookieService.get("PA.wsocponecare");
    //   if(sess && (!response || response.error)) {
    //     window.location.reload();
    //   }
    // }, (err1: any) => {
    //   console.error("Checksession request failed, logging user off.", err1);
    //   window.location.reload();
    // });

    this.route.queryParams.subscribe(params => {
      let q, filterkey;

      q = params['q'];
      if (q && q != null && q != undefined) {
        this.searchTerm = q;
        filterkey = params['filterkey'];
        if (filterkey && filterkey != null && filterkey != undefined) {
          this.filterCategory = filterkey;
        }
        this.getSearchResultJsonResponse();
      }
    });

    // Search auto-suggestion api call
    this.searchCtrl.valueChanges.pipe(debounceTime(300)).subscribe(value => {
      this.noSuggestion = false;
      if(!this.filterCategory || (this.filterCategory && this.filterCategory !== "onecareservice_catalog")) {
        if (value) {
          this.toHighlight = value;
          if (value && value.trim().length > 2) {
            this.isLoading = true;
            let url = "cs/Satellite?pagename=CustomerOps/Search/getAutoSuggestions&q=" + value.replace(/\&/g, "%26").trim() + "&usertype=" + this.userInfo.usertype;
            this.ds.getData(url).subscribe((data: any) => {
              this.isLoading = false;
              if (data && data['results']) {
                this.suggestionList = data['results'];
                this.noSuggestion = false;
              } else {
                this.suggestionList = [];
                this.noSuggestion = true;
              }
            }, err => {
              this.isLoading = false;
              this.suggestionList = [];
              this.noSuggestion = true;
              console.error("Suggestion failure", err);
            });
          }
        } else {
          this.isLoading = false;
          this.noSuggestion = false;
          this.suggestionList  = [];
        }
      }
    });

    if(currentUrl.indexOf('/home/myrequests') > -1) {
      this.OpenRequestsView('my');
    } else if(currentUrl.indexOf('/home/dgrequests') > -1) {
      this.OpenRequestsView('dgrequests');
    } else if(currentUrl.indexOf('/home/history') > -1) {
      this.OpenRequestsView('history');
    }
  }

  getSearchTerm() {
    this.searchservice
      .getSearchTerm()
      .subscribe(data => {
        if (Object.keys(data).length > 0) {
          this.searchTerm = data;
          this.getSearchResultJsonResponse();
        }
        if (window.location.href.indexOf(this.localLangCode.replace("/", "") + "/search") > -1) {
          this.checkUrl = true;
        }
      });
  }

  clickEvent(textData: string) {
    this.change = !this.change;
    this.pageChange = 1;
    if (textData === 'oneCare') {
      this.profile = "onecare_servicecatalog";
      this.isLoadingResults = true;
      this.onPageChange(this.pageChange);
      let url = '/cs/Sites?lookuphost=/customercare&lookuppage=' + this.localLangCode.replace("/", "") + '/searchresults&sortBy=relevance&profile=' + this.filterCategory + '&currentPage=' + this.pageChange + '&pageSize=10&partialfields=&q=' + this.searchTerm + '&filterCategory=' + this.filterCategory + '&filterLang=' + encodeURIComponent(this.filterLang) + '&filterDocumentType=' + encodeURIComponent(this.filterDocumentType) + '&filterContentType=' + encodeURIComponent(this.filterContentType) + '&FilterType=' + this.FilterType + '&source=onecare';
      this.ds.getSearchHtmlResponse(url)
        .subscribe(data => {
          this.responseResult(data);
        });
    } else {
      this.profile = "avaya_en";
      this.isLoadingResults = true;
      this.onPageChange(this.pageChange);

      let url = '/cs/Sites?lookuphost=/customercare&lookuppage=' + this.localLangCode.replace("/", "") + '/searchresults&sortBy=relevance&profile=' + this.filterCategory + '&currentPage=' + this.pageChange + '&pageSize=10&partialfields=&q=' + this.searchTerm + '&filterCategory=' + this.filterCategory + '&filterLang=' + encodeURIComponent(this.filterLang) + '&filterDocumentType=' + encodeURIComponent(this.filterDocumentType) + '&filterContentType=' + encodeURIComponent(this.filterContentType) + '&FilterType=' + this.FilterType + '&source=onecare';
      this.ds.getSearchHtmlResponse(url)
        .subscribe(data => {
          this.responseResult(data);
        });
    }
  }

  onPageChange = (event: any) => {
    window.scrollTo(0, 0);
    this.pageChange = event;

    this.getSearchResultJsonResponse();
    let checkValue = this.pageChange * 10;
    this.fromSearchResult = checkValue - 9;
    if (checkValue < this.totalRecords) {
      this.toSearchResult = checkValue;
    } else {
      this.toSearchResult = this.totalRecords;
    }
  }

  doNothing() {
    return;
  }

  showOutage() {
    let showOutageList = 'showOutage';
    this.router.navigate([this.localLangCode + '/serviceoutage'], {
      queryParams: {
        outage: showOutageList,
        modal: 'show',
        origin: this.localLangCode + '/requests'
      }
    });
  }

  getSearchResultJsonResponse() {
    this.isLoadingResults = true;
    this.searchResultJsonResponse = '';
    this.profile = "aco_en";

    let url = '/cs/Sites?lookuphost=/customercare&lookuppage=' + this.localLangCode.replace("/", "") + '/searchresults&sortBy=relevance&profile=' + this.filterCategory + '&currentPage=' + this.pageChange + '&pageSize=10&partialfields=&q=' + this.searchTerm.replace(/'/g, " ") + '&filterCategory=' + this.filterCategory + '&filterLang=' + encodeURIComponent(this.filterLang) + '&filterDocumentType=' + encodeURIComponent(this.filterDocumentType) + '&filterContentType=' + encodeURIComponent(this.filterContentType) + '&FilterType=' + this.FilterType + '&source=onecare';
    this.ds.getSearchHtmlResponse(url)
      .subscribe(data => {
        this.checkTotalResults(data)
      });
  }

  checkTotalResults(data: any) {
    this.isLoadingResults = false;
    if (data.body.totalResults == 0 || data.body.totalResults == "0") {
      this.totalRecords = 0
    }
    this.responseResult(data);
  }

  responseResult(data: any) {
    this.searchResultJsonResponse = data;
    this.isLoadingResults = false;
    let checkValue = this.pageChange * 10;
    this.fromSearchResult = checkValue - 9;
    if (checkValue < this.totalRecords) {
      this.toSearchResult = checkValue;
    } else {
      this.toSearchResult = this.totalRecords;
    }
  }

  resetSearch() {
    this.showHideSearch = !this.showHideSearch;
    this.searchCtrl.reset();
  }

  //this function opens a default view from a profile dropdown.
  openDefaultView() {
    this.infoMenu = false;
    this.viewSettingIcon = true;
  }

  selectChangeHandler() {
    this.selectedDropdown = this.viewId;
    let url = "/customercare/en/home/user?action=update&viewid=" + this.selectedDropdown;
    this.ds.getData(url)
      .pipe(
        catchError(val => of(`ERROR sending data ${val}`))
      )
      .subscribe(resp => {
        window.location.reload();
      });
  }

  toggleMobileview() {
    this.showMenu = !this.showMenu;
    this.callMyProfileService();
  }

  //This funcions opens the delagation view from a profile dropdown.
  openDelgatesView() {
    this.infoMenu = false;
    this.viewSettingIcon = false;
    this.defaultSettingIcon = true;
    let deligationUrl = '/customercare/en/home/user?action=getDelegUser';

    this.ds.getData(deligationUrl)
      .pipe(catchError(val => of(`ERROR sending data ${val}`)))
      .subscribe(resp => {
        this.responseArray = [];
        this.deligationInitialResponse = resp;
        let deligationData = (this.deligationInitialResponse.delegUsers && this.deligationInitialResponse.delegUsers.length) ? this.deligationInitialResponse.delegUsers.split(',') : [];
        deligationData.forEach((loopvalue: any) => {
          if (loopvalue.length >= 3 && loopvalue != 'null') {
            this.responseArray.push(loopvalue);
          }
        });
        if (this.responseArray && this.responseArray.length >= 5) {
          this.hideInitalResponseInputBox = true;
        } else {
          this.hideInitalResponseInputBox = false;
          this.userProfileFormValueChanges();
        }
      })
  }

  openProfileDropdown() {
    this.infoMenu = true;
    this.viewSettingIcon = false;
    this.defaultSettingIcon = false;
    this.callMyProfileService();
  }

  OpenRequestsView(type: string) {
    if(this.isMobView) {
      this.showHideSearch = false;
      this.showMenu = false;
    }
    this.ui.openRequestsTab.next(type);
    this.hideOtherCompsEmit.emit(false);
    // added this condition, when user is on search page and clicks on My Request button from header
    if(window.location.href.includes(this.localLangCode + "/search"))
      window.location.href = this.localLangCode + "/home/myrequests";
    else if(type === "my")
      this.router.navigate([this.localLangCode + "/home/myrequests"]);
    else if(type === "dgrequests")
      this.router.navigate([this.localLangCode + "/home/dgrequests"]);
    else if(type === "history")
      this.router.navigate([this.localLangCode + "/home/history"]);

    this.closeProfileDropdown();
  }

  callMyProfileService() {
    this.checkingDown = this.views.forEach(defaultview => {
      if (defaultview.defaultview) {
        this.viewId = defaultview.id;
        this.initialDefaultDropdown = defaultview.id;
      }
    });
    const url = "/customercare/en/home/user?action=add&viewid=" + this.viewId;
    this.ds.getData(url)
      .pipe(catchError(val => of(`ERROR sending data ${val}`)))
      .subscribe(resp => { });
  }

  closeMenuItems() {
    let dropdowns = this.el.nativeElement.querySelectorAll(".menu-dropdown,.menuList");
    for (let i = 0; i < dropdowns.length; i++) {

      dropdowns[i].classList.remove('open');
      let arrowIcons = dropdowns[i].querySelectorAll('.rotate,.active')
      arrowIcons.forEach((icon: any) => {
        icon.classList.remove('rotate')
        icon.classList.remove('active')
      });
      dropdowns[i].classList.remove('active');
    }
  }

  closeProfileDropdown() {
    this.infoMenu = false;
    this.defaultSettingIcon = false;
    this.viewSettingIcon = false;
    this.hideListMenus = false;
    const dropdowns = this.el.nativeElement.querySelectorAll(".cop-prof");
    for (let i = 0; i < dropdowns.length; i++) {
      dropdowns[i].classList.remove('open');
      dropdowns[i].classList.remove('active');
    }
  }

  get mobiles() {
    if (this.responseArray || this.mobiles) {
      if ((this.responseArray && this.responseArray.length <= 5) || this.mobiles.controls.length <= 5) {
        return this.userprofileForm?.get('mobiles') as UntypedFormArray;
      }
    }
  }

  backToMainMenu() {
    this.infoMenu = true;
    this.defaultSettingIcon = false;
    this.viewSettingIcon = false;
    this.showInvalidDelegationMsg = false;
    this.activeInputUserArray = [];
    this.userprofileForm = this.fb.group({
      mobiles: this.fb.array([
        this.fb.control('')
      ]),
    })
  }

  userProfileFormValueChanges() {
    this.userprofileForm?.get('mobiles')?.valueChanges.subscribe(user => {

      let duplicateResponseArray;
      // Check if user input is available in Existing Array or not
      if (this.responseArray) {
        duplicateResponseArray = this.responseArray.find(element => {
          return element == user[0].trim();
        });
      }

      // Check if user input is available in Latest inputs
      const duplicateInputs = this.activeInputUserArray.find(element => {
        return element == user[0].trim();
      });

      this.finalInputArray = user[0].trim();

      // If Duplicate Value, Alert User with Notification
      if ((duplicateResponseArray || duplicateInputs) && user[0].trim() != this.uibase.userInfo.uid) {
        // Show Error Message
        this.showInvalidDelegationMsg = true;
        // Hide Add Button
        this.addButtonFlag = false;
        // Hide Apply Settings Button
        this.disableApplySetting = true;
      } else {
        // Hide Error Message
        this.showInvalidDelegationMsg = false;
        // Show Add Button
        this.addButtonFlag = true;

        // Max Limit Validation for 5
        if (((this.responseArray && this.responseArray.length) + this.mobiles.length) > 4) {
          this.addButtonFlag = false;
          this.disableApplySetting = false;
        }
        if (this.responseArray && this.responseArray.length < 5) {
          this.disableApplySetting = false;
        }
      }
    });
  }

  /**
   * Validate Delegate User Exist / Not
   * Make a service call and based on the response process the remaining flow
   */
  validateDelegateUser(user) {
    let url;
    if (this.environmentUrlIslocal) {
      url = 'http://localhost:4200/cs/cop/assets/data/delegation.json';
    } else {
      url = '/cops/user/actions/checkuserid?uid=' + user;
    }

    if (user.toString().indexOf('@') >= 0) {
      url = '/cops/user/actions/checkuser/?emailid=' + user;
    }
    this.ds
      .deligationGetData(url)
      .subscribe(resp => {
        this.userIdresponse = <Deligation>resp;

        // User Already Exists - Failed Scenario
        if ((this.userIdresponse && this.userIdresponse.Status == "UserNotExist") || user == this.uibase.userInfo.uid) {
          // Show Error Message
          this.showInvalidDelegationMsg = true;
          // Hide Add Button
          this.addButtonFlag = false;
          this.disableApplySetting = true;
        } else {

          // User Exist - Success Scenario
          // Show Apply Settings Button
          this.disableApplySetting = false;

          // this.mobiles.push(this.fb.control(''));
          // Create New Form Control only if the existing length is less than 5
          if (user !== 'e' || user !== '') {
            // Push User to active array

            // Disable Previous Valid input controls

            if (this.activeInputUserArray.length == 0) {
              this.userprofileForm.controls.mobiles.get("0").disable();
              if (((this.responseArray && this.responseArray.length) + this.mobiles.length) > 5) {
                this.addButtonFlag = false;
              } else {
                this.mobiles.push(this.fb.control(''));
              }
            } else {
              let BreakException = {};
              try {
                this.activeInputUserArray.forEach((elem, index) => {

                  // Enable Readonly for previous Inputs
                  if (this.mobiles.length === index) {

                  } else {
                    this.userprofileForm.controls.mobiles.get((this.mobiles.length - 1).toString()).disable();
                    if (((this.responseArray && this.responseArray.length) + this.mobiles.length) > 4) {
                      this.addButtonFlag = false;
                    } else {
                      this.mobiles.push(this.fb.control(''));
                      throw BreakException;
                    }
                  }
                })
              } catch (e) {
                if (e !== BreakException) throw e;
              }
            }
            this.activeInputUserArray.push(user);
          }
          return;
        }
      })
  }

  addInputDeligation() {
    this.addButtonFlag = false;
    if ((this.responseArray && this.mobiles) && (this.responseArray.length + this.mobiles.length) <= 5) {
      let checkInpuVal = this.userprofileForm.controls.mobiles.get((this.mobiles.length - 1).toString()).value;

      // Validate User Existance using service call
      if (checkInpuVal !== '') {
        this.validateDelegateUser(this.userprofileForm.controls.mobiles.get((this.mobiles.length - 1).toString()).value.trim());
      } else {
        // Show Error Message
        this.showInvalidDelegationMsg = true;
        // Hide Add Button
        this.addButtonFlag = false;
        // Hide Apply Settings Button
        this.disableApplySetting = true;
      }
    }
  }

  deleteRow(index: number) {
    this.mobiles.removeAt(index);
    this.activeInputUserArray.splice(index, 1);
    if (this.responseArray && this.responseArray.length <= 5) {
      this.addButtonFlag = true;
    }
  }

  deleteInitialValue(index: number) {
    this.responseArray.splice(index, 1);
    if (this.responseArray.length <= 0 || this.responseArray == undefined) {
      this.responseArray = null;
    }
    this.selectedDropdown = this.viewId;
    this.url = "/customercare/en/home/user?action=update&viewid=" + this.selectedDropdown + '&delegUser=' + this.responseArray;
    this.ds.getData(this.url)
      .pipe(
        catchError(val => of(`ERROR sending data ${val}`))
      )
      .subscribe(resp => {
        if (this.responseArray == null) {
          window.location.reload();
          this.userprofileForm = this.fb.group({
            mobiles: this.fb.array([
              this.fb.control('')
            ]),
          })
          this.openDelgatesView();
        }
        if ((this.responseArray && this.mobiles) && (this.mobiles.length + this.responseArray.length) <= 5) {
          this.hideInitalResponseInputBox = false;
        } else {
          this.hideInitalResponseInputBox = true;
        }
        if (this.responseArray && this.responseArray.length <= 5) {
          this.addButtonFlag = true;
        }
      })
  }

  //this function gets called after clicking apply settings button of delegation view
  saveDelegatesList() {
    this.selectedDropdown = this.viewId;
    let serviceResp = this.responseArray;
    let mobileInputs = [];
    let user = this.userprofileForm.controls.mobiles.get((this.mobiles.length - 1).toString()).value;
    if (user == '') {
      user = this.userprofileForm.controls.mobiles.get((this.mobiles.length - 2).toString()).value;
    } else {
      user = this.userprofileForm.controls.mobiles.get((this.mobiles.length - 1).toString()).value;
    }
    if (user && user != "") {
      let url;
      if (this.environmentUrlIslocal) {
        url = 'http://localhost:4200/cs/cop/assets/data/delegation.json';
      } else {
        url = '/cops/user/actions/checkuserid?uid=' + user;
      }

      if (user.toString().indexOf('@') >= 0) {
        url = '/cops/user/actions/checkuser/?emailid=' + user;
      }

      this.ds
        .deligationGetData(url)
        .subscribe(resp => {
          this.userIdresponse = <Deligation>resp;

          // User Already Exists - Failed Scenario
          if (this.userIdresponse && this.userIdresponse.Status == "UserNotExist") {
            // Show Error Message
            this.showInvalidDelegationMsg = true;
            // Hide Add Button
            this.addButtonFlag = false;
          } else { // User Exist - Success Scenario
            this.mobiles.controls.forEach(inputValue => {
              mobileInputs.push(inputValue.value);
            })

            // POST SETTING SERVICE CALL
            if (mobileInputs.concat(serviceResp).length > 0) {
              this.url = "/customercare/en/home/user?action=update&viewid=" + this.selectedDropdown + '&delegUser=' + mobileInputs.concat(serviceResp);
              this.ds.getData(this.url)
                .pipe(
                  catchError(val => of(`ERROR sending data ${val}`))
                )
                .subscribe(resp => {
                  // window.location.reload();
                  let response = JSON.parse(JSON.stringify(resp));
                  this.userprofileForm = this.fb.group({
                    mobiles: this.fb.array([
                      this.fb.control('')
                    ]),
                  });
                  if (response && response.status === "Success") {
                    this.sendEmailTodelegateUsers(mobileInputs);
                  }
                  this.backToMainMenu();
                })
            } else {
              this.url = "/customercare/en/home/user?action=update&viewid=" + this.selectedDropdown;
              this.ds.getData(this.url)
                .pipe(
                  catchError(val => of(`ERROR sending data ${val}`))
                )
                .subscribe(resp => {
                  let response = JSON.parse(JSON.stringify(resp));
                  // window.location.reload();
                  this.userprofileForm = this.fb.group({
                    mobiles: this.fb.array([
                      this.fb.control('')
                    ]),
                  })
                  if (response && response.status === "Success") {
                    this.sendEmailTodelegateUsers(mobileInputs);
                  }
                  this.backToMainMenu();
                })
            }
          }
        })
    }
  }

  //this method is used to send email notification to delegated users
  sendEmailTodelegateUsers(currentUsers) {
    let url = 'sendDelegateEmail'
    let dataForm = new FormData();
    dataForm.append('OldDelegateUsers', this.responseArray.join());
    dataForm.append('NewDelegateUsers', currentUsers.join())

    this.ds.postData(url, dataForm)
      .pipe(
        catchError(val => of(`ERROR sending data ${val}`))
      )
      .subscribe(resp => {
        // window.location.reload();
      })
  }

  linkTarget(link, targetType) {
    if (!link.HasSubHeaderLink) {
      window.open(link.url, targetType);
    }
    //this.showMenu = !this.showMenu;
  }

  ngOnDestroy() {
    this.pollingData.unsubscribe();
  }

  onOptionsSelected(event: any, value: string) {
    if (this.fileinput != null) {
      if (this.fileinput.nativeElement.value != "")
        this.disabledSelect = false;
      else
        this.disabledSelect = true;
    }

    this.greyTitleText = value;

    for (let i = 0; i < this.stat.length; i++) {
      if (event.target.value == this.stat[i].name) {
        this.filtered = this.stat.filter(t => t.name == this.selected);
        this.filterCategory = this.stat[i].key;
      }
    }
    this.pageChange = 1;
    if (this.fileinput != null) {
      this.searchTerm = this.fileinput.nativeElement.value;
    }
    // bigSearch content
    if (this.searchTerm.trim() !== "") {
      window.location.href = '/customercare' + this.localLangCode + '/search?q=' + this.searchTerm + '&profile=' + this.filterCategory + '&source=onecare';
    } else
      this.isSearchTermBlank = true;
  }

  getfileinput(event: any, val?: string) {
    if (this.fileinput) {
      this.greyTitleText = this.oneCareAvayaKnowledgeMsg;
      if (this.fileinput.nativeElement.value != "")
        this.isSearchTermBlank = false;
      else
        this.isSearchTermBlank = true;
    }

    if (event.keyCode === 13 || event.which === 1) {
      this.pageChange = 1;
      if (this.fileinput) {
        this.searchTerm = this.fileinput.nativeElement.value;

        if(val) {
          // to convert copyright, trademark, etc special chars
          const parser = new DOMParser();
          const decodedString = parser.parseFromString(val, "text/html").body.textContent;
          this.searchCtrl.setValue(decodedString);
          this.searchTerm = decodedString;
        }

        if (this.searchTerm) {
          setTimeout(() => {
            this.getSearchResultJsonResponse();
            window.location.href = '/customercare' + this.localLangCode + '/search?q=' + this.searchTerm.replace(/\'|\"/g, "%22").replace(/\&/g, "%26") + '&profile=' + this.filterCategory + '&source=onecare';
          }, 500);
        } else
          this.isSearchTermBlank = true;
      }
      // bigSearch content
    }
  }

  onLogout() {
    localStorage.clear();
    sessionStorage.clear();
  }

  /**
   * Function to fetch translated text
   */
  setLocalizationText() {
    this.translator.get("OneCareAvayaKnowledge").subscribe((res: string) => {
        this.oneCareAvayaKnowledgeMsg = res;
    });
  }
}
